module.exports = __webpack_public_path__ + "static/media/iconMetricPM10.f9f15304.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Icons/iconMetricPM10.svg
// module id = 1133
// module chunks = 0